import React from 'react';

import { Box, Typography } from '@mui/material';

import SearchBar from '../../../common/components/SearchBar';
import { SearchResult } from '../../../common/types/SearchResult';
import ResultsFilterMenuButton from '../../components/MenuButton/ResultsFilterMenuButton';
import ResultsTable, {
  Order,
} from '../../components/ResultsTable/ResultsTable';
import {
  defaultResultsFilters,
  NoteStatusFilterOption,
} from '../../constants/FilterOptions';
import useFilteredResults from '../../hooks/useFilteredResults';
import MenuOption from '../../types/MenuOption';

import '../AdminContent.scss';

const ResultsScreen: React.FC = () => {
  const [resultsFilters, setResultsFilters] = React.useState<
    MenuOption<NoteStatusFilterOption>[]
  >(defaultResultsFilters);

  const rowsPerPage = 9;

  const [searchText, setSearchText] = React.useState<string | undefined>(
    undefined
  );
  const [sortParams, setSortParams] = React.useState<{
    sortField?: string;
    direction?: string;
  }>({ sortField: 'id', direction: 'DESC' });

  const {
    filteredResults: results,
    isLoading: usersIsLoading,
    total,
    page,
    setPage,
  } = useFilteredResults(rowsPerPage, resultsFilters, sortParams, searchText);

  const updateFilterOption = (
    filters: MenuOption<NoteStatusFilterOption>[],
    option: MenuOption<NoteStatusFilterOption>,
    checked: boolean
  ) => {
    return filters.map((filter) => {
      if (filter.item === option.item) {
        filter.selected = checked;
      }
      return filter;
    });
  };

  const handleStatusFilterSelection = (
    option: MenuOption<NoteStatusFilterOption>,
    checked: boolean
  ) => {
    const update = updateFilterOption(resultsFilters, option, checked);
    setResultsFilters(update);
  };

  const handleClear = () => {
    setSearchText(undefined);
  };

  const handleSearch = (text: string) => {
    setSearchText(text);
  };

  const requestSort = (property: keyof SearchResult, order: Order) => {
    let sortField: string = property;
    sortField = property;
    setSortParams({ sortField, direction: order.toUpperCase() });
  };

  return (
    <Box className='white-background min-height-100'>
      <Box className='content-wrapper'>
        <Box className='row-wrapper'>
          <SearchBar
            handleClear={handleClear}
            handleSearch={handleSearch}
            placeholder='Search'
          />
          <Box className='filters-row'>
            <Typography color='text.secondary'>Filter by:</Typography>
            <ResultsFilterMenuButton
              sx={{
                marginRight: '16px',
                marginLeft: '16px',
              }}
              title='Status'
              options={resultsFilters}
              handleSelection={handleStatusFilterSelection}
            />
          </Box>
        </Box>
        <ResultsTable
          requestSort={requestSort}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          total={total}
          results={results}
          isLoading={usersIsLoading}
        />
      </Box>
    </Box>
  );
};

export default ResultsScreen;
